import {useEffect} from 'react'
import {useNavigate, useRouteLoaderData} from 'react-router-dom'
import {User} from '../services/UserService'

export function useCurrentUser() {
  const {user} = (useRouteLoaderData('root') as {user: User}) || {}
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      navigate('/')
    }
  }, [user])

  return user
}
